export default __webpack_public_path__ + "static/media/insta.02dd2722.png";